const MOTIVATION_NOTE =
  "Siz qanday natijaga erishmang, bu sizning o'sish nuqtangizdir. Hozirgi holatni to'g'ri qabul qilib, keyingi bosqichda yanada yaxshi natija uchun ishlash muhim.";

const ensureList = value =>
  Array.isArray(value)
    ? value.filter(Boolean)
    : typeof value === 'string' && value.trim()
      ? value
          .split(',')
          .map(item => item.trim())
          .filter(Boolean)
      : [];

const RESULT_CONTENT = {
  'temperament-test': {
    1: {
      eyebrow: 'Temperament natijasi',
      label: 'Xolerik',
      tone: 'success',
      summary: "Kuchli, chaqqon va harakatga tez kirishadigan temperament turi.",
      description:
        "Xoleriklar kuchli, chaqqon, jizzaki va harakatchan bo'ladi. Ular faol va ishchan, lekin ish ritmini bir maromda ushlab turish qiyin bo'lishi mumkin. Tezkor vazifalarda kuchli ko'rinishadi, sabr va izchillik talab qiladigan ishlar esa alohida nazoratni talab qiladi.",
      guidance:
        "Kundalik rejalarda qisqa tanaffuslar, hissiy bosimni boshqarish va bir vazifaga yakun yasab keyingisiga o'tish foydali.",
      recommendations: [
        "Shoshilinch qarorlar oldidan qisqa pauza qiling.",
        "Yirik vazifalarni kichik bosqichlarga bo'lib bajaring.",
        "Zo'riqish ortgan paytda dam olish ritmini oldindan belgilang."
      ]
    },
    2: {
      eyebrow: 'Temperament natijasi',
      label: 'Sangvinik',
      tone: 'info',
      summary: "Moslashuvchan, ochiq va tez aloqa o'rnatadigan temperament turi.",
      description:
        "Sangviniklar quvnoq, tirishqoq va ta'sirchan bo'ladi. Ular yangi muhitga tez moslashadi, muloqotga oson kirishadi va ishga jadal kirishib keta oladi. Shu bilan birga, uzoq muddatli bir xil ritmdagi vazifalarda diqqatni ushlab turish uchun tartib kerak bo'ladi.",
      guidance:
        "Faollikni barqaror natijaga aylantirish uchun reja, ustuvorlik va yakuniy nazorat foyda beradi.",
      recommendations: [
        "Bir vaqtning o'zida ortiqcha ko'p ish ochib yubormang.",
        "Kun yakunida nima bitganini qisqa qayd qiling.",
        "Muloqot kuchli tomoningizni jamoaviy ishlarda faol ishlating."
      ]
    },
    3: {
      eyebrow: 'Temperament natijasi',
      label: 'Flegmatik',
      tone: 'warning',
      summary: "Vazmin, bosiq va barqaror ishlashga moyil temperament turi.",
      description:
        "Flegmatiklar shoshmasdan, puxta va izchil ishlaydi. Ular murakkab vaziyatlarda ham hissiy muvozanatni yaxshi saqlaydi va qat'iylik talab qiladigan ishlarni bardavom olib boradi. Tez javob talab qilinadigan vaziyatlarda esa sekinlik sezilishi mumkin.",
      guidance:
        "Barqarorlik kuchli tomoningiz. Tezkor vazifalar uchun oldindan tayyor shablon va ish algoritmi foydali bo'ladi.",
      recommendations: [
        "Tezkor vazifalar uchun vaqt cheklovli mini-mashqlar qiling.",
        "Oldindan tayyor cheklistlar bilan ishlang.",
        "Murakkab, uzoq davom etadigan ishlar sizga ko'proq mos tushadi."
      ]
    },
    4: {
      eyebrow: 'Temperament natijasi',
      label: 'Melanxolik',
      tone: 'danger',
      summary: "Nozik sezgirlik va ichki kechinmalar kuchli bo'lgan temperament turi.",
      description:
        "Melanxoliklar hissiy jihatdan sezgir, ehtiyotkor va chuqur o'ylaydigan bo'ladi. Ular mayda noqulayliklarni ham kuchliroq his qilishi mumkin va tashqi bosim ularga og'irroq ta'sir qiladi. Shu bilan birga, nozik kuzatuvchanlik va chuqur tahlil qilish qobiliyati kuchli bo'ladi.",
      guidance:
        "Psixologik yuklama kuchaysa, hissiy holatni yolg'iz ichga yutib yubormasdan, tayanch odam yoki mutaxassis bilan gaplashish foydali.",
      recommendations: [
        "Ish va dam olish o'rtasida aniq chegara qiling.",
        "Hissiy charchoq paytida o'zingizni tiklash odatini yarating.",
        "Qo'llab-quvvatlovchi muhitni ongli ravishda tanlang."
      ]
    }
  },
  kommunikativ: {
    1: {
      eyebrow: 'Kommunikativ natija',
      label: "Moyilliklari sust",
      tone: 'danger',
      summary: "Muloqot va tashkiliy faollik hozircha past darajada.",
      description:
        "Siz notanish muhitda tashabbusni tez qo'lga olmaysiz, ko'pchilik oldida gapirish yoki tez aloqa boshlash noqulay tuyilishi mumkin. Bu qat'iy kamchilik emas, balki rivojlantiriladigan ko'nikma.",
      guidance:
        "Muloqot ko'nikmalari odatda kichik va muntazam amaliyot bilan yaxshilanadi.",
      recommendations: [
        "Kichik guruhlarda fikr bildirishni odat qiling.",
        "Oldindan tayyorlangan savollar bilan suhbat boshlang.",
        "Har hafta kamida bitta yangi ishchi muloqotni sinab ko'ring."
      ]
    },
    2: {
      eyebrow: 'Kommunikativ natija',
      label: "O'rtachadan past",
      tone: 'secondary',
      summary: "Muloqotga kirishasiz, lekin tashabbus har doim ham barqaror emas.",
      description:
        "Aloqa qilishga intilish bor, biroq yangi odamlar, katta auditoriya yoki tez moslashish talab qilinadigan vaziyatlarda ishonch pasayishi mumkin. Tashkiliy mas'uliyatni hamma vaqt o'z zimmangizga olmaysiz.",
      guidance:
        "Barqarorlik uchun muloqot va tashkiliy vazifalarni kichik bosqichlarda ko'paytirish foydali.",
      recommendations: [
        "Uchrashuvlarda kamida bitta faol savol bering.",
        "Kichik tashkiliy vazifalarni o'zingizga oling.",
        "Qulay bo'lgan muloqot usullaringizni ko'paytirib boring."
      ]
    },
    3: {
      eyebrow: 'Kommunikativ natija',
      label: "O'rtacha",
      tone: 'warning',
      summary: "Kommunikativ va tashkiliy moyilliklar me'yoriy darajada.",
      description:
        "Siz odamlar bilan ishlashga intilasiz, fikringizni himoya qila olasiz va vaziyatga qarab tashabbus ham ko'rsatasiz. Biroq bu xususiyatlar har doim bir xil barqarorlikda namoyon bo'lmasligi mumkin.",
      guidance:
        "Yaxshi darajani yuqoriga olib chiqish uchun yetakchilik va chiqishlar sonini oshirish foydali.",
      recommendations: [
        "Jamoaviy ishda moderatsiya rolini sinab ko'ring.",
        "Taqdimot va qisqa chiqishlarga ko'proq qatnashing.",
        "Muloqotdan keyin o'zingizga qisqa tahlil yozing."
      ]
    },
    4: {
      eyebrow: 'Kommunikativ natija',
      label: 'Yuqori',
      tone: 'info',
      summary: "Muloqot va tashkilotchilik bo'yicha kuchli ko'rsatkich.",
      description:
        "Siz yangi sharoitda o'zingizni yo'qotmaysiz, tanishlar doirasini kengaytirishga intilasiz va ijtimoiy faoliyatda tashabbus ko'rsatishga moyilsiz. Murakkab vaziyatlarda ham mustaqil qaror qabul qilish qobiliyati seziladi.",
      guidance:
        "Bu kuchli tomonni jamoa bilan ishlash, loyiha boshqaruvi va liderlik vazifalarida faol qo'llash mumkin.",
      recommendations: [
        "Loyihalarda koordinatsiya rolini oling.",
        "Jamoa ichida fikrlarni yig'ish va birlashtirishga e'tibor bering.",
        "Yetakchilikni natija va mas'uliyat bilan muvozanatlang."
      ]
    },
    5: {
      eyebrow: 'Kommunikativ natija',
      label: 'Juda yuqori',
      tone: 'success',
      summary: "Kommunikativ va tashkilotchilik salohiyati juda yuqori.",
      description:
        "Siz yangi muhitda o'zingizni erkin tutasiz, tashabbus ko'rsatishga tayyorsiz va jamoani ortingizdan ergashtira olasiz. Tadbirlarda, tashkilotchilikda va tezkor ijtimoiy muloqotlarda kuchli ko'rinasiz.",
      guidance:
        "Yuqori ijtimoiy faollikni strategik fikrlash va tinglash madaniyati bilan birga olib borish eng yaxshi natija beradi.",
      recommendations: [
        "Jamoa ichida liderlikni tinglash bilan uyg'unlashtiring.",
        "Faollikni aniq maqsad va muddatlarga bog'lang.",
        "Ko'p vazifalikda ustuvorliklarni yo'qotmaslikka e'tibor bering."
      ]
    }
  },
  motivatsiya: {
    1: {
      eyebrow: 'Motivatsiya natijasi',
      label: 'Sust',
      tone: 'danger',
      summary: "Yutuqqa yo'nalgan ichki motivatsiya hozircha past.",
      description:
        "Maqsad sari yurishda ichki rag'bat tez so'nib qolishi yoki tashqi turtki kuchliroq kerak bo'lishi mumkin. Bu holat resurs, muhit va maqsadning aniqligi bilan bog'liq bo'lishi mumkin.",
      guidance:
        "Motivatsiyani kuchaytirish uchun maqsadni kichik, o'lchanadigan bosqichlarga bo'lish foydali.",
      recommendations: [
        "Katta maqsadni haftalik mini-natijalarga ajrating.",
        "Bajarilgan ishni ko'rinadigan joyda qayd qilib boring.",
        "Qaysi vazifalar sizga haqiqatan ma'no berishini aniqlang."
      ]
    },
    2: {
      eyebrow: 'Motivatsiya natijasi',
      label: "O'rtacha",
      tone: 'warning',
      summary: "Muvaffaqiyatga intilish barqaror, lekin kuchaytirish imkoniyati bor.",
      description:
        "Sizda oldinga yurish uchun zarur ichki turtki mavjud, biroq murakkab yoki uzoq davom etadigan vazifalarda ritm pasayishi mumkin. To'g'ri reja bilan natijani oshirish mumkin.",
      guidance:
        "Natijani ushlab turish uchun ritm, nazorat va ichki rag'bat manbalarini birlashtiring.",
      recommendations: [
        "Ish boshlash vaqtini qat'iy belgilang.",
        "Har bir bosqich uchun yakun mezonini yozib qo'ying.",
        "Mukofot va dam olishni vazifalar bilan bog'lang."
      ]
    },
    3: {
      eyebrow: 'Motivatsiya natijasi',
      label: 'Yuqori',
      tone: 'info',
      summary: "Yutuqqa erishish motivatsiyasi ancha yuqori.",
      description:
        "Siz maqsadga yo'nalgan, natija ko'rishni istaydigan va o'sishga ochiq holatdasiz. Vazifalarga ma'no bera olsangiz, ish jarayonida energiyani yaxshi ushlab turasiz.",
      guidance:
        "Bu darajani ushlab turish uchun ortiqcha kuyib ketishning oldini olish ham muhim.",
      recommendations: [
        "Yirik maqsadlar yoniga tiklanish vaqtini ham rejalashtiring.",
        "Natijani faqat tezlik bilan emas, sifat bilan ham baholang.",
        "O'zgarishlarni davriy ravishda o'lchab boring."
      ]
    },
    4: {
      eyebrow: 'Motivatsiya natijasi',
      label: 'Juda yuqori',
      tone: 'success',
      summary: "Yutuqqa yo'nalish va ichki rag'bat juda kuchli.",
      description:
        "Siz oldinga siljish, o'sish va maqsadga erishish bo'yicha juda yuqori ichki energiyaga egasiz. To'g'ri yo'naltirilsa, bu katta natijalarga olib keladi.",
      guidance:
        "Juda yuqori motivatsiya kuchli natija beradi, lekin uni haddan tashqari bosimga aylantirib yubormaslik kerak.",
      recommendations: [
        "O'z oldingizga real va ketma-ket maqsadlar qo'ying.",
        "Natija uchun ishlash bilan tiklanish muvozanatini saqlang.",
        "Yetakchilik va namuna ko'rsatishda bu kuchni foydali ishlating."
      ]
    }
  },
  teylor: {
    1: {
      eyebrow: 'Bezovtalanish natijasi',
      label: 'Juda yuqori bezovtalanish',
      tone: 'danger',
      summary: "Hissiy zo'riqish va ichki xavotir darajasi yuqori ko'rinmoqda.",
      description:
        "Kundalik vaziyatlarda ham ichki bosim, taranglik yoki noaniqlikni kuchliroq his qilishingiz mumkin. Bu o'qish, ishlash va dam olish ritmiga ta'sir qilishi ehtimol.",
      guidance:
        "Agar bu holat tez-tez takrorlansa, psixolog bilan ishlash yoki hissiy boshqaruv usullarini amaliyotga kiritish foydali bo'ladi.",
      recommendations: [
        "Uyqu va dam olish ritmini tartibga soling.",
        "Nafas mashqlari va jismoniy faollikni muntazam qiling.",
        "Uzoq davom etuvchi bezovtalikda mutaxassis bilan maslahat qiling."
      ]
    },
    2: {
      eyebrow: 'Bezovtalanish natijasi',
      label: 'Yuqori bezovtalanish',
      tone: 'warning',
      summary: "Bezovtalik darajasi yuqori, lekin boshqarish imkoniyati mavjud.",
      description:
        "Stressli vaziyatlar sizga kuchliroq ta'sir qilishi mumkin. Holat doimiy bo'lmasa ham, ba'zi paytlarda hissiy zo'riqish ish unumiga ta'sir qilishi ehtimol.",
      guidance:
        "Profilaktik usullarni erta qo'llash bezovtalikni chuqurlashmasdan boshqarishga yordam beradi.",
      recommendations: [
        "Ish kunida qisqa tiklanish pauzalarini qo'shing.",
        "Bir vaqtning o'zida ortiqcha vazifa olmaslikka harakat qiling.",
        "Stress omillarini yozib, ularni kamaytirish yo'lini tuzing."
      ]
    },
    3: {
      eyebrow: 'Bezovtalanish natijasi',
      label: "O'rtacha bezovtalanish",
      tone: 'info',
      summary: "Bezovtalik me'yoriy darajaga yaqin.",
      description:
        "Sizda xavotir va ichki taranglik kuzatilishi mumkin, lekin u odatda boshqariladigan chegarada. Bu daraja ko'pchilikda uchraydigan tabiiy holatga yaqin.",
      guidance:
        "Sog'lom ritm va o'zini kuzatish odati bu darajani barqaror ushlab turadi.",
      recommendations: [
        "Rejalashtirish va ustuvorlikni aniq saqlang.",
        "Dam olishni kechiktirmang.",
        "Hissiy yuklama oshgan paytlarni kuzatib boring."
      ]
    },
    4: {
      eyebrow: 'Bezovtalanish natijasi',
      label: 'Quyi bezovtalanish',
      tone: 'success',
      summary: "Hissiy xavotir darajasi quyi ko'rinmoqda.",
      description:
        "Siz vaziyatlarga nisbatan nisbatan xotirjam yondashasiz va ichki bosimni odatda yaxshi boshqarasiz. Bu barqarorlik ish va o'qish ritmida yordam beradi.",
      guidance:
        "Bu holatni saqlash uchun mavjud sog'lom odatlaringizni davom ettiring.",
      recommendations: [
        "Barqaror ritmni saqlang.",
        "Stress paydo bo'lganida ham odatiy boshqaruv usullarini davom ettiring.",
        "Yuklama ortsa ham dam olish muvozanatini yo'qotmang."
      ]
    }
  },
  nevratsiya: {
    1: {
      eyebrow: 'Nevrasteniya natijasi',
      label: 'Odatiy holat',
      tone: 'success',
      summary: "Ko'rsatkichlar odatiy psixologik holatga yaqin.",
      description:
        "Javoblar bo'yicha kuchli nevrastenik belgilar ko'zga tashlanmadi. Bu hissiy va asabiy zo'riqish me'yoriy chegarada ekanini anglatadi.",
      guidance:
        "Mavjud muvozanatni saqlash uchun uyqu, dam olish va yuklama muvozanatini davom ettirish foydali.",
      recommendations: [
        "Ish va tiklanish ritmini saqlang.",
        "Uzoq davom etadigan charchoqni e'tiborsiz qoldirmang.",
        "Faol dam olishni hayot ritmiga qo'shing."
      ]
    },
    2: {
      eyebrow: 'Nevrasteniya natijasi',
      label: 'Yengil nevrasteniya',
      tone: 'warning',
      summary: "Yengil asabiy charchoq va zo'riqish belgilari seziladi.",
      description:
        "Natija yengil nevrastenik alomatlar borligini ko'rsatadi. Bu ko'pincha charchoq, yuklama yoki tiklanish ritmining buzilishi bilan bog'liq bo'ladi.",
      guidance:
        "Alohida e'tibor dam olish sifati, ish yuklamasi va hissiy zo'riqishni kamaytirishga qaratilishi kerak.",
      recommendations: [
        "Kun tartibida to'liq dam olish vaqtini belgilang.",
        "Uzoq davom etuvchi yuklamalarda tanaffusni ko'paytiring.",
        "Alomatlar saqlansa, mutaxassis bilan maslahat qiling."
      ]
    },
    3: {
      eyebrow: 'Nevrasteniya natijasi',
      label: 'Yaqqol nevrasteniya',
      tone: 'danger',
      summary: "Asabiy charchoq ko'rsatkichlari yaqqol ko'rinmoqda.",
      description:
        "Natija hissiy va asabiy zo'riqish kuchliroq darajada ekanini ko'rsatadi. Bu holat kundalik unumdorlik va umumiy holatga ta'sir qilishi mumkin.",
      guidance:
        "Agar holat takrorlansa yoki uzoq davom etsa, psixolog yoki shifokor bilan bevosita maslahatlashish tavsiya etiladi.",
      recommendations: [
        "Yuklamani qisqartirish va tiklanishga ustuvorlik bering.",
        "Uyqu va dam olish rejimini qat'iylashtiring.",
        "Mutaxassis bilan maslahatni kechiktirmang."
      ]
    }
  },
  'kasb-test': {
    1: {
      eyebrow: "Kasb yo'nalishi",
      label: 'Kasbiy tip H',
      resultCode: 'H',
      tone: 'success',
      summary: "Ijodkorlik va nozik did kuchli ko'rinmoqda.",
      description:
        "Didingiz nozik, g'oyalar va obrazlar bilan ishlash sizga yaqin. Siz estetik sezgi, tasavvur va ijodiy yondashuv talab qiladigan rollarda o'zingizni yaxshi namoyon qilishingiz mumkin.",
      guidance:
        "Ijodiy salohiyatni amaliy ko'nikmalar bilan birlashtirsangiz, natija yanada barqaror bo'ladi.",
      careers: ['Dizayner', "San'atkor", 'Vizajist'],
      recommendations: [
        "Portfolio yoki ijodiy ishlar to'plamini shakllantiring.",
        "Vizual fikrlashni amaliy loyihalarda sinab ko'ring.",
        "Estetik didni kuchaytiradigan mashg'ulotlarga vaqt ajrating."
      ]
    },
    2: {
      eyebrow: "Kasb yo'nalishi",
      label: 'Kasbiy tip L',
      resultCode: 'L',
      tone: 'info',
      summary: "Odamlar bilan ishlash va ijtimoiy rol kuchli tomoningiz.",
      description:
        "Muloqot, odamlarni tushunish va tashkiliy faollik sizga yaqin. Ijtimoiy dinamika mavjud bo'lgan kasblarda samarali ishlashingiz mumkin.",
      guidance:
        "Bu yo'nalishda tinglash, ta'sir o'tkazish va tizimli ishlash ko'nikmalari ayniqsa muhim.",
      careers: ['Reklama vakili', 'Menejer', 'Prodyuser', 'Psixolog', 'Vrach', "O'qituvchi", 'Jurnalist'],
      recommendations: [
        "Jamoa va mijoz bilan ishlash amaliyotini ko'paytiring.",
        "Taqdimot va muzokara ko'nikmalarini rivojlantiring.",
        "Ijtimoiy rollarda mas'uliyatni ongli boshqaring."
      ]
    },
    3: {
      eyebrow: "Kasb yo'nalishi",
      label: 'Kasbiy tip P',
      resultCode: 'P',
      tone: 'warning',
      summary: "Amaliy, kuzatuvchan va tabiatga yaqin yo'nalishlar sizga mos.",
      description:
        "Siz ishni puxta ko'rib chiqib boshlashga moyilsiz va amaliy natija ko'rinadigan faoliyat sizga mos tushadi. Tabiat, jismoniy muhit va shakl bilan ishlash qiziqish uyg'otadi.",
      guidance:
        "Nazariy qiziqishni amaliy ko'nikma bilan bog'lash bu yo'nalishda asosiy omil bo'ladi.",
      careers: ['Fitodizayner', 'Kosmetolog', "Inter'er dizayneri", 'Fermer', 'Veterinar', 'Arxitektor', 'Trener'],
      recommendations: [
        "Amaliy loyiha va ustaxona tajribasini ko'paytiring.",
        "Kuzatuvchanlikni real mahsulot yoki xizmatga bog'lang.",
        "Tabiat va amaliy muhit bilan ishlash tajribasini yig'ing."
      ]
    },
    4: {
      eyebrow: "Kasb yo'nalishi",
      label: 'Kasbiy tip A',
      resultCode: 'A',
      tone: 'secondary',
      summary: "Tahlil, tekshiruv va izlanishga yo'naltirilgan tip.",
      description:
        "Qiziquvchanlik, tekshirish va sababni topishga intilish kuchli. Murakkab vaziyatlarni tahlil qilish, tekshirish va aniqlik talab qiladigan rollar sizga mos tushishi mumkin.",
      guidance:
        "Bu salohiyatni tizimli fikrlash va hujjat bilan ishlash intizomi bilan birlashtirish muhim.",
      careers: ['Xususiy izquvar', 'Psixoanalitik', 'Yurist', 'Marketolog', 'Ekolog', 'Tekshiruvchi', 'Sinovchi'],
      recommendations: [
        "Tahliliy yozuv va xulosa chiqarish ko'nikmasini oshiring.",
        "Muammolarni tekshirish algoritmlarini o'rganing.",
        "Ma'lumot bilan ishlash aniqligiga e'tibor qarating."
      ]
    },
    5: {
      eyebrow: "Kasb yo'nalishi",
      label: 'Kasbiy tip K',
      resultCode: 'K',
      tone: 'danger',
      summary: "Rahbarlik va ta'sir doirasi yuqori bo'lgan rollar sizga yaqin.",
      description:
        "Yetakchilik, boshqaruv va odamlarni maqsad atrofida birlashtirish salohiyati kuchli. Tashabbus, qaror qabul qilish va strategik ta'sir talab qiladigan vazifalar sizga mos tushadi.",
      guidance:
        "Liderlikni uzoq muddatli natija, mas'uliyat va jamoa ishonchi bilan birga olib borish kerak.",
      careers: ['Siyosatchi', 'Korxona egasi', 'Advokat', 'Firma direktori', 'Prezident'],
      recommendations: [
        "Liderlikni tinglash va mas'uliyat bilan uyg'unlashtiring.",
        "Strategik fikrlash va delegatsiyani kuchaytiring.",
        "Qarorlar ta'sirini oldindan baholash odatini yarating."
      ]
    }
  },
  'dipressiya-test': {
    1: {
      eyebrow: 'Depressiya natijasi',
      label: 'Yuqori xavf',
      tone: 'danger',
      summary: "Ruhiy siqilish kuchliroq kechayotgan bo'lishi mumkin.",
      description:
        "Sizning javoblaringiz bo'yicha kayfiyat tushishi, ichki bosim va ruhiy siqilish kuchliroq ekanini ko'rsatmoqda. Agar bu holat davomli bo'lsa, kundalik faoliyatga salbiy ta'sir qilishi mumkin.",
      guidance:
        "Mutaxassis bilan bevosita suhbatlashish va yaqin qo'llab-quvvatlovchi muhitga murojaat qilish tavsiya etiladi.",
      recommendations: [
        "Holatingizni yolg'iz ichga yutib yurmaslikka harakat qiling.",
        "Ishonchli odam yoki mutaxassis bilan suhbatni kechiktirmang.",
        "Uyqu, dam olish va kun tartibini imkon qadar tartibga soling."
      ]
    },
    2: {
      eyebrow: 'Depressiya natijasi',
      label: "O'rta daraja",
      tone: 'info',
      summary: "Ruhiy siqilish o'rtacha darajada namoyon bo'lmoqda.",
      description:
        "Ba'zi vaziyatlarda kayfiyat pasayishi, ichki bosim yoki tushkunlik hissi paydo bo'lishi mumkin. Holat barqaror kuchli bo'lmasa ham, e'tiborsiz qoldirmaslik foydali.",
      guidance:
        "Dam olish ritmi, ijtimoiy tayanch va muntazam o'zini kuzatish bunday holatni chuqurlashmasdan boshqarishga yordam beradi.",
      recommendations: [
        "Sizni charchatadigan omillarni yozib boring.",
        "Kayfiyat pasaygan kunlarda rejani yengillashtiring.",
        "Zarurat bo'lsa, psixologik maslahatdan foydalaning."
      ]
    },
    3: {
      eyebrow: 'Depressiya natijasi',
      label: 'Barqaror holat',
      tone: 'success',
      summary: "Depressiv xavf ko'rsatkichlari past yoki sezilmaydi.",
      description:
        "Natija bo'yicha siz hayotga nisbatan ijobiyroq va barqarorroq fonni saqlab turibsiz. Bu holatni davom ettirish uchun sog'lom odatlar va ijtimoiy tayanch muhim.",
      guidance:
        "Mavjud psixologik barqarorlikni qo'llab-quvvatlash profilaktik jihatdan ham foydali.",
      recommendations: [
        "Sog'lom ritm va dam olish tartibini davom ettiring.",
        "Qiyin davrlar uchun tayanch odatlar ro'yxatini saqlang.",
        "Ijobiy muhit va ijtimoiy aloqalarni mustahkamlab boring."
      ]
    }
  },
  'suitsit-test': {
    1: {
      eyebrow: 'Suitsid xavfi natijasi',
      label: 'Suistiddan yiroq',
      tone: 'success',
      summary: "Natija bo'yicha suitsidal xavf ko'rsatkichlari past ko'rinmoqda.",
      description:
        "Javoblaringizda o'ziga zarar yetkazishga yaqin kuchli signal ko'zga tashlanmadi. Bu baribir psixologik holatni umumiy kontekstda baholash kerak emas degani emas.",
      guidance:
        "Barqarorlikni saqlash va qiyin davrlarda tayanch aloqalarni ushlab turish foydali.",
      recommendations: [
        "Hissiy holat yomonlashsa, tayanch odamlar bilan aloqani uzmang.",
        "Stressni boshqarish odatlarini davom ettiring.",
        "Agar ichki bosim ortsa, mutaxassis bilan suhbatni kechiktirmang."
      ]
    },
    2: {
      eyebrow: 'Suitsid xavfi natijasi',
      label: "O'ziga nisbatan biroz e'tibortalab",
      tone: 'info',
      summary: "Ichki qo'llab-quvvatlash va e'tibor ehtiyoji sezilishi mumkin.",
      description:
        "Javoblarda hissiy tayanch va atrofdagilar e'tiboriga ehtiyoj signallari ko'rinadi. Bu sizga muntazam qo'llab-quvvatlovchi muhit foydali bo'lishini anglatadi.",
      guidance:
        "Holatingizni yaqin insonlar yoki mutaxassis bilan bo'lishish profilaktik jihatdan foydali.",
      recommendations: [
        "Sizni eshita oladigan tayanch inson bilan muntazam gaplashing.",
        "Emotsional bosim paytida yolg'iz qolib ketmaslikka harakat qiling.",
        "Qo'llab-quvvatlash so'rashni kechiktirmang."
      ]
    },
    3: {
      eyebrow: 'Suitsid xavfi natijasi',
      label: "Salbiy holatlarga ta'sirchan",
      tone: 'warning',
      summary: "Stress va salbiy holatlarga sezgirlik kuchliroq bo'lishi mumkin.",
      description:
        "Qiyin vaziyatlar sizga kuchliroq ta'sir qilishi, ichki bosimni og'irroq his qilishingiz mumkin. Bu natija psixologik tayanch va kuzatuvni kuchaytirish kerakligini bildiradi.",
      guidance:
        "Davomli zo'riqishda psixolog bilan ishlash yoki ishonchli tayanch doirani kuchaytirish tavsiya etiladi.",
      recommendations: [
        "Qiyin vaziyatda yolg'iz qaror qabul qilmaslikka harakat qiling.",
        "Hissiy signal kuchaysa, yaqin odamga darhol xabar bering.",
        "Mutaxassis bilan maslahatlashishdan tortinmang."
      ]
    },
    4: {
      eyebrow: 'Suitsid xavfi natijasi',
      label: 'Chuqurroq psixologik tashxis',
      tone: 'danger',
      summary: "Natija bo'yicha mutaxassis bilan chuqurroq suhbat zarur bo'lishi mumkin.",
      description:
        "Javoblar kuchliroq psixologik xavf signalini ko'rsatmoqda. Bu yakuniy tashxis emas, lekin holatni mutaxassis bilan tezroq muhokama qilishni talab qiladi.",
      guidance:
        "Agar ichki bosim, umidsizlik yoki o'ziga zarar yetkazish fikrlari bo'lsa, mutaxassis va yaqinlar bilan darhol aloqa qilish kerak.",
      recommendations: [
        "Mutaxassis bilan uchrashuvni kechiktirmang.",
        "Yolg'iz qolib ketmaslikka harakat qiling.",
        "Zudlik bilan tayanch va xavfsizlik rejasini tuzing."
      ]
    }
  }
};

export const resolveStudentResultContent = rawResult => {
  if (!rawResult || typeof rawResult !== 'object') {
    return {
      eyebrow: 'Test natijasi',
      label: 'Natija saqlandi',
      tone: 'secondary',
      summary: "Test yakunlandi va javoblaringiz tizimga yozildi.",
      description: "Natija tafsilotlari yuklanmadi, ammo test muvaffaqiyatli yakunlangan.",
      guidance: "Talaba kirishi orqali keyinroq qayta tekshirishingiz mumkin.",
      recommendations: [],
      careers: [],
      motivationNote: MOTIVATION_NOTE,
      resultCode: ''
    };
  }

  const kalit = String(rawResult.kalit || '').trim();
  const natija = Number(rawResult.natija || 0);
  const content = (RESULT_CONTENT[kalit] && RESULT_CONTENT[kalit][natija]) || null;

  if (content) {
    return {
      ...content,
      careers: ensureList(content.careers),
      recommendations: ensureList(content.recommendations),
      motivationNote: MOTIVATION_NOTE
    };
  }

  return {
    eyebrow: rawResult.subject ? `${rawResult.subject} natijasi` : 'Test natijasi',
    label: 'Natija saqlandi',
    tone: 'secondary',
    summary: "Test yakunlandi va javoblaringiz tizimga yozildi.",
    description:
      "Mazkur test uchun batafsil avtomatik sharh hozircha mavjud emas. Natija tizimda saqlandi va mutaxassis tomonidan ko'rib chiqilishi mumkin.",
    guidance: "Talaba panelidan chiqib qayta kirish yoki administrator panelidagi natijalar bilan solishtirish mumkin.",
    recommendations: [],
    careers: [],
    motivationNote: MOTIVATION_NOTE,
    resultCode: ''
  };
};

export default resolveStudentResultContent;
